import {Component, Input, numberAttribute} from '@angular/core';

import {SimpleLibelleComponent} from '../simple-libelle/simple-libelle.component';

//Composant contrôle conteneur
@Component (
{
  selector: 'val-controle-conteneur',
  imports: 
  [
    SimpleLibelleComponent
  ],
  templateUrl: './controle-conteneur.component.html',
  styleUrl: './controle-conteneur.component.scss'
})
export class ControleConteneurComponent 
{
  //Création
  constructor () 
  {
    this.label = "";
  }

  //Label
  @Input ()
  public label: string;

  //Taille du label
  @Input ({transform: numberAttribute})
  public tailleLabel?: number;
}
